import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import logger from './utils/logger';

export default createStore(reducers, applyMiddleware(thunk, logger));
